"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThinContentModelUtilities = void 0;
const enums_1 = require("../../enums");
const ContentManagerContent_1 = require("./ContentManagerContent");
const MeetingsContent_1 = require("./MeetingsContent");
const PracticeContent_1 = require("./PracticeContent");
const ThinContentModel_1 = require("./ThinContentModel");
const WorkspaceContent_1 = require("./WorkspaceContent");
const ChannelsContent_1 = require("./ChannelsContent");
class ThinContentModelUtilities {
    static deserialize(serializedContent) {
        if (!serializedContent || !serializedContent.trim()) {
            throw new Error(serializedContent);
        }
        const repositoryString = serializedContent.substring(0, serializedContent.indexOf(ThinContentModel_1.ThinContentModel.SerializeFieldSeparator));
        if (!(repositoryString in enums_1.ContentRepository)) {
            throw new Error(repositoryString);
        }
        const repository = repositoryString;
        switch (repository) {
            case enums_1.ContentRepository.ContentManager:
                return ContentManagerContent_1.ContentManagerContent.deserialize(serializedContent);
            case enums_1.ContentRepository.Workspace:
                return WorkspaceContent_1.WorkspaceContent.deserialize(serializedContent);
            case enums_1.ContentRepository.Practice:
                return PracticeContent_1.PracticeContent.deserialize(serializedContent);
            case enums_1.ContentRepository.Meetings:
                return MeetingsContent_1.MeetingsContent.deserialize(serializedContent);
            case enums_1.ContentRepository.Channels:
                return ChannelsContent_1.ChannelsContent.deserialize(serializedContent);
            default:
                throw new Error(`${repository} is not a support repository`);
        }
    }
}
exports.ThinContentModelUtilities = ThinContentModelUtilities;
